import { render, staticRenderFns } from "./ApexoToggle.vue?vue&type=template&id=1b073d48&"
import script from "./ApexoToggle.vue?vue&type=script&lang=js&"
export * from "./ApexoToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports